import { render, staticRenderFns } from "./WizardPage4.vue?vue&type=template&id=400b934e"
import script from "./WizardPage4.vue?vue&type=script&lang=js"
export * from "./WizardPage4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports